export default "__VITE_ASSET__8RFR1k$G__"